// extracted by css-extract-rspack-plugin
export default {"container":"container-vTwuFA"};